import { IEnrollableStudentResponse } from '@/types/views/student.types';
import { GridPaginationModel } from '@mui/x-data-grid';
import { queryKeys } from './queryKeys';
import { useAppQuery } from './useAppQuery';

interface Props {
  searchDebounce?: string;
  paginationModel?: GridPaginationModel;
}

/**
 * The students the training manager may enrol — the whole permitted roster. Deliberately NOT
 * filtered by what any of them already holds: see useGetEnrolmentPreview for what a given
 * (student, course) pair would cost.
 */
export const useGetEnrollableStudents = ({ searchDebounce, paginationModel }: Props) => {
  return useAppQuery<IEnrollableStudentResponse>('/TrainingManager/enrollable-students', {
    queryKey: queryKeys.enrollableStudents.list({ searchDebounce, paginationModel }),
    config: {
      params: {
        searchText: searchDebounce,
        pageNumber: (paginationModel?.page || 0) + 1,
        pageSize: paginationModel?.pageSize || undefined,
      },
      paramsSerializer: { indexes: null },
    },
    placeholderData: undefined,
  });
};
